import * as orderActionsLogService from 'services/orderActionLogService';
import useSWR from 'swr';
import type { AxiosError } from 'axios';
import type { GetOrderActionsNoDateRequest } from 'services/dtoModels/order/getOrderActionsNoDateRequest';
import type { Paginator } from 'services/dtoModels/paginator';
import type { SWRResponse } from 'swr';

type SWROrderActionsLogData = Awaited<
  ReturnType<typeof orderActionsLogService.getOrderActionsNoDateAsync>
>;

const useOrderActionsNoDate = (
  params: GetOrderActionsNoDateRequest & Paginator,
  load = true
): SWRResponse<SWROrderActionsLogData, AxiosError> =>
  useSWR(
    load ? [SWR_ORDER_ACTIONS_NO_DATE_ENDPOINT, params] : null,
    async ([_, params]) => await orderActionsLogService.getOrderActionsNoDateAsync(params)
  );

export const SWR_ORDER_ACTIONS_NO_DATE_ENDPOINT = 'order-actions-no-date';
export default useOrderActionsNoDate;
